// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ReportSourceSchema = z.enum(['MANUAL','SCHEDULED','ON_DEMAND'] as const);

export type ReportSourceType = `${z.infer<typeof ReportSourceSchema>}`

export default ReportSourceSchema;
